<template>
<div  >

    <div class="row mt-2 align-items-center mb-1">
       <div class="col-sm-3 col-12 ">
            <div v-if="category" class="categoryTitle ms" @click="resetSearch()"><img :src="category.icon" v-if="category.icon" /> <span v-else>{{category.title}}</span></div>
        </div>
         <div class="col-sm-9 col-12">
            <div class="row">
                <div class="col-sm-5 readButton text-center">
                    <v-btn small class="ma-2" depressed color="blue-grey lighten-1" dark @click="data.viewed='A',getItems()">อ่านแล้ว</v-btn>
                    <v-btn small class="ma-2" outlined color="blue-grey lighten-1" dark @click="data.viewed='H',getItems()">ยังไม่ได้อ่าน</v-btn>
                </div>
                 <div class="col-sm-6 col-8">
                    <v-text-field label="ค้นหา" v-model="data.keyword" outlined hide-details=""></v-text-field>
                </div>

                <div class="col-sm-1 pl-0 col-4">

                    <v-btn icon large color="red" @click="data.viewed=null,getItems()">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>

    </div>

    <div v-if="items" class="contestItems mt-5" :class="itemsCss">

        <div class="row ">
            <div class="col-md-4 col-sm-6 col-12 mb-5" v-for="item in items" :key="item.content_id">

                <v-card class="mx-auto pa-0" elevation="1" :class="item.css" :style="item.style">

                    <v-card-text class="pa-0">

                        <router-link :to="{name:'TestContest',params:{item_id:item.content_id}}">
                            <div class="row">
                                <div class="col-sm-5 pt-0 pb-0"> <img :src="item.picture.picture_small" style="width:100%;" /></div>
                                <div class="col-sm-7">
                                    <div class="itemTitle ms pa-2"><span>{{item.title}} </span></div>
                                    <div class="text-center mt-2">
                                        <span v-if="item.pretest=='A'" class="itemPretest">PRE TEST</span>
                                        <span v-if="item.posttest=='A'" class="itemPosttest">POST TEST</span>
                                    </div>
                                </div>

                            </div>
                        </router-link>
                    </v-card-text>
                </v-card>

            </div>
        </div>

    </div>

    <div class="pg">
        <Paginator v-if="totalItemsCount>0" :rows="12" :totalRecords="totalItemsCount" @page="onPage($event)"></Paginator>
    </div>
</div>
</template>

<script>
export default {

    components: {

    },
    props: {
        category: null 
    },

    data: () => ({

        data: {},
       data: {
            keyword: null,
            cat_in: null,
            category_id: null,
            viewed: null

        },

        totalItemsCount: 0,

        page: 0,
        items: null,
        itemsCss: null

    }),

    computed: {

    },

    watch: {

    },
    methods: {

           resetSearch() {

            this.data.keyword = null
            this.data.viewed = null
           this.getItems()
        },

    getItems() {

            let url = "content/list?page=" + this.page;

            this.$FULL_LOADING = true
            let $vm = this;

            this.data = this.category

            const formData = this.$formData(
                this.data
            );

            this.$API
                .post(url, $vm.formData(formData, true))
                .then(function (res) {

                    $vm.checkApi(res)
                    $vm.totalItemsCount = res.data.total
                    $vm.items = res.data.items
                    $vm.itemsCss = res.data.itemsCss

                })
                .catch(function (error) {
                    console.log(error);

                });

        },
        onPage(event) {

            console.log(event)
            this.page = event.page + 1
            this.getItems()

            this.setPageNo(this.page)

        },

    },
    created() {

        if (this.pageNo) {
            this.page = this.pageNo
        }

        this.getItems();

    },
};
</script>
